import React from 'react';

import {IFeatureToggle} from './types';

export const FeatureToggleContext = React.createContext({
  isLoading: false,
  features: [] as IFeatureToggle[],
});
